import type { FunctionComponent } from 'react';

import { PopoverMenu, PopoverMenuButton } from '@trello/nachos/popover-menu';

interface NewPluginPopoverListProps {
  items: {
    text: string;
    callback: () => void;
  }[];
}

export const NewPluginPopoverList: FunctionComponent<
  NewPluginPopoverListProps
> = ({ items }) => {
  return (
    <div>
      <PopoverMenu>
        {items.map((item) => {
          return (
            <PopoverMenuButton key={item.text} onClick={item.callback}>
              {item.text}
            </PopoverMenuButton>
          );
        })}
      </PopoverMenu>
    </div>
  );
};
